<template>
  <div class="stats-wrapper">
    <div class="MiniStatsSlider-styles-slide">

      <VueContentLoading :width="300" v-if="loading">
        <rect x="48" y="8" rx="3" ry="3" width="88" height="6" />
        <rect x="48" y="26" rx="3" ry="3" width="52" height="6" />
        <rect x="0" y="56" rx="3" ry="3" width="410" height="6" />
        <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
        <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />
        <circle cx="20" cy="20" r="20" />
        <circle cx="277" cy="20" r="20" />
        <rect x="160" y="7" rx="3" ry="3" width="88" height="6" />
        <rect x="193" y="24" rx="3" ry="3" width="52" height="6" />
      </VueContentLoading>

      <div v-if="!data && !loading">
        <div class="MiniStatsError-styles-error-wrapper">
          <span class="MiniStatsError-styles-icon"></span>
          <p><span>{{ t.not_found_match_stats_message }}</span></p>
        </div>
        <div class="SliderFooter-styles-slider-dots-container"></div>
        <div id="full_stats" class="SliderFooter-styles-full-view-link"><a href="/tr/event/513449010/full">İstatistikleri gör</a></div>
      </div>

      <swiper ref="mySwiper" class="" :options="swiperOptions" v-if="data && data.hasOwnProperty('h2h')">
        <swiper-slide>
          <div class="slider-1">
            <div class="SlideOne-styles-h2h">
              <div class="SlideOne-styles-row">
                <span class="Competitors-styles-strong">{{ data.h2h.EntityList[0]['Name'] }}</span>
                <span class="Competitors-styles-strong">{{ data.h2h.EntityList[1]['Name'] }}</span></div>
              <div class="SlideOne-styles-row">
                <div class="WinsDrawsWins-styles-results">
                  <span class="WinsDrawsWins-styles-strong">{{ data.h2h.Entity1ItemStatistics['Win']['Value'] }}</span>Galibiyet</div>
                <div class="WinsDrawsWins-styles-results"><span class="WinsDrawsWins-styles-strong">{{ data.h2h.Entity1ItemStatistics['Draw']['Value'] + data.h2h.Entity2ItemStatistics['Draw']['Value'] }}</span>Beraberlik</div>
                <div class="WinsDrawsWins-styles-results"><span class="WinsDrawsWins-styles-strong">{{ data.h2h.Entity2ItemStatistics['Win']['Value'] }}</span>Galibiyet</div>
              </div>
              <div class="SlideOne-styles-row Tendencies-styles-container">
                <div class="Tendencies-styles-tendency">
              <span v-for="w in data.h2h.Matches1['WDL'].slice(0, 6)" class="Tendencies-styles-tendency-item"
                    :class="(w === 'W') ? 'Tendencies-styles-won' : ((w === 'L') ? 'Tendencies-styles-lost' : 'Tendencies-styles-draw')"

                    v-html="w"
              >
              </span>
                </div>
                <div class="Tendencies-styles-tendency-center">Form</div>
                <div class="Tendencies-styles-tendency">
              <span v-for="w in data.h2h.Matches2['WDL'].slice(0, 6)" class="Tendencies-styles-tendency-item"
                    :class="(w === 'W') ? 'Tendencies-styles-won' : ((w === 'L') ? 'Tendencies-styles-lost' : 'Tendencies-styles-draw')"

                    v-html="w"
              >
              </span>
                </div>
              </div>
            </div>
            <div class="SlideOne-styles-table">
              <div class="SlideOne-styles-row StatsDivider-styles-divider" v-if="data.standings">
                <div class="StatsDivider-styles-line"></div>
                <div class="StatsDivider-styles-table-title">{{ t.national }} {{ data.standings[0].PathName }}</div>
                <div class="StatsDivider-styles-line"></div>
              </div>
              <div class="SlideOne-styles-row ThreeColRanking-styles-container" v-if="data.standings">
                <div v-if="data.standings && s.Name === data.h2h.EntityList[0]['Name']" v-for="s in data.standings[0].Standings">
              <span class="ThreeColRanking-styles-rank ThreeColRanking-styles-bold">
              <span>#</span>{{ s.PosAll }}</span>&nbsp;
                  <span v-for="p in s.WebLeagueTables" v-if="p.Key === 'PTS' && p.TransLation === 'All'" class="ThreeColRanking-styles-light" data-testid="team1-points">({{ p.Value }}pts)</span>
                  &nbsp;
                </div>
                <div>{{ t.standings }}</div>
                <div v-if="data.standings && s.Name === data.h2h.EntityList[1]['Name']" v-for="s in data.standings[0].Standings">
              <span class="ThreeColRanking-styles-rank ThreeColRanking-styles-bold">
              <span>#</span>{{ s.PosAll }}</span>&nbsp;
                  <span v-for="p in s.WebLeagueTables" v-if="p.Key === 'PTS' && p.TransLation === 'All'" class="ThreeColRanking-styles-light" data-testid="team1-points">({{ p.Value }}pts)</span>
                  &nbsp;
                </div>
              </div>
              <!--
              <div class="SlideOne-styles-row ThreeColRanking-styles-container">
                <div><span class="ThreeColRanking-styles-rank">52<span>%</span></span>&nbsp;&nbsp;<span class="ThreeColRanking-styles-light" data-testid="team-over-under">(<span class="ThreeColRanking-styles-bold">11</span>/21)</span></div>
                <div>2,5 Gol Üstü</div>
                <div>&nbsp;<span class="ThreeColRanking-styles-light" data-testid="team-over-under">(<span class="ThreeColRanking-styles-bold">12</span>/21)</span><span class="ThreeColRanking-styles-rank ThreeColRanking-styles-bold"><span>&nbsp;</span>57<span>%</span></span></div>
              </div> !-->
              <div class="SlideOne-styles-row ThreeColRanking-styles-container">
                <div><span class="ThreeColRanking-styles-rank">{{ data.h2h.Entity1ItemStatistics['GoalsTotal']['Value'] }}</span>&nbsp;</div>
                <div>Maç başına atılan gol</div>
                <div><span class="ThreeColRanking-styles-rank"><span>&nbsp;</span>{{ data.h2h.Entity2ItemStatistics['GoalsTotal']['Value'] }}</span></div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slider-2" v-if="data.hasOwnProperty('standings')">
            <div class="SlideTwo-styles-standings-double">
              <div class="SlideTwo-styles-row SlideTwo-styles-float">
                <div class="LeagueSectionHeader-styles-standings-headings LeagueSectionHeader-styles-standings-headings-titles">{{ t.standings }}</div>
                <ul class="LeagueSectionHeader-styles-standings-headings">
                  <li>O</li>
                  <li>G</li>
                  <li>B</li>
                  <li>M</li>
                  <li class="LeagueSectionHeader-styles-goal-scored-conceded">AG</li>
                  <li class="LeagueSectionHeader-styles-goal-scored-conceded">YG</li>
                  <li>AV</li>
                  <li>P</li>
                </ul>
              </div>
              <div class="SlideTwo-styles-row SlideTwo-styles-float LeagueStats-styles-standings"
                   v-if="data.standings && s.Name === data.h2h.EntityList[0]['Name']" v-for="s in data.standings[0].Standings"
              >
                <span class="LeagueStats-styles-strong">{{ s.PosAll }}</span>
                <span class="LeagueStats-styles-standings-team">{{ data.h2h.EntityList[0]['Name'] }}</span>
                <ul class="LeagueStats-styles-standings-stats">
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PLD' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'W' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'D' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'L' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GF' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GA' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'GD' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PTS' && p.TransLation === 'All'" class="LeagueStats-styles-strong">{{ p.Value }}</li>
                </ul>
              </div>
              <div class="StatsListSeparator-styles-separator-container">
                <div class="StatsListSeparator-styles-col1">
                  <ul class="StatsListSeparator-styles-col1 StatsListSeparator-styles-separator-dots">
                    <li class="StatsListSeparator-styles-dot"></li>
                    <li class="StatsListSeparator-styles-dot"></li>
                    <li class="StatsListSeparator-styles-dot"></li>
                    <li class="StatsListSeparator-styles-dot"></li>
                  </ul>
                </div>
                <div class="StatsListSeparator-styles-separator-line"></div>
              </div>
              <div class="SlideTwo-styles-row SlideTwo-styles-float LeagueStats-styles-standings"
                   v-if="data.standings && s.Name === data.h2h.EntityList[1]['Name']" v-for="s in data.standings[0].Standings"
              >
                <span class="LeagueStats-styles-strong">{{ s.PosAll }}</span>
                <span class="LeagueStats-styles-standings-team">{{ data.h2h.EntityList[1]['Name'] }}</span>
                <ul class="LeagueStats-styles-standings-stats">
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PLD' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'W' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'D' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'L' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GF' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GA' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'GD' && p.TransLation === 'All'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PTS' && p.TransLation === 'All'" class="LeagueStats-styles-strong">{{ p.Value }}</li>
                </ul>
              </div>
            </div>
            <div class="SlideTwo-styles-standings-single">
              <div class="SlideTwo-styles-row SlideTwo-styles-float">
                <div class="LeagueSectionHeader-styles-standings-headings LeagueSectionHeader-styles-standings-headings-titles">{{ t.home }}</div>
                <ul class="LeagueSectionHeader-styles-standings-headings">
                  <li>O</li>
                  <li>G</li>
                  <li>B</li>
                  <li>M</li>
                  <li class="LeagueSectionHeader-styles-goal-scored-conceded">AG</li>
                  <li class="LeagueSectionHeader-styles-goal-scored-conceded">YG</li>
                  <li>AV</li>
                  <li>P</li>
                </ul>
              </div>
              <div class="SlideTwo-styles-row SlideTwo-styles-float LeagueStats-styles-standings"
                   v-if="data.standings && s.Name === data.h2h.EntityList[0]['Name']" v-for="s in data.standings[0].Standings"
              >
                <span class="LeagueStats-styles-strong">{{ s.PosAll }}</span>
                <span class="LeagueStats-styles-standings-team">{{ data.h2h.EntityList[0]['Name'] }}</span>
                <ul class="LeagueStats-styles-standings-stats">
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PLD' && p.TransLation === 'Home'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'W' && p.TransLation === 'Home'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'D' && p.TransLation === 'Home'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'L' && p.TransLation === 'Home'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GF' && p.TransLation === 'Home'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GA' && p.TransLation === 'Home'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'GD' && p.TransLation === 'Home'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PTS' && p.TransLation === 'Home'" class="LeagueStats-styles-strong">{{ p.Value }}</li>
                </ul>
              </div>
              <div class="SlideTwo-styles-row SlideTwo-styles-float">
                <div class="SlideTwo-styles-col1"></div>
                <div class="SlideTwo-styles-separator-line"></div>
              </div>
            </div>
            <div class="SlideTwo-styles-standings-single">
              <div class="SlideTwo-styles-row SlideTwo-styles-float">
                <div class="LeagueSectionHeader-styles-standings-headings LeagueSectionHeader-styles-standings-headings-titles">{{ t.away }}</div>
                <ul class="LeagueSectionHeader-styles-standings-headings">
                  <li>O</li>
                  <li>G</li>
                  <li>B</li>
                  <li>M</li>
                  <li class="LeagueSectionHeader-styles-goal-scored-conceded">AG</li>
                  <li class="LeagueSectionHeader-styles-goal-scored-conceded">YG</li>
                  <li>AV</li>
                  <li>P</li>
                </ul>
              </div>
              <div class="SlideTwo-styles-row SlideTwo-styles-float LeagueStats-styles-standings"
                   v-if="data.standings && s.Name === data.h2h.EntityList[1]['Name']" v-for="s in data.standings[0].Standings"
              >
                <span class="LeagueStats-styles-strong">{{ s.PosAll }}</span>
                <span class="LeagueStats-styles-standings-team">{{ data.h2h.EntityList[1]['Name'] }}</span>
                <ul class="LeagueStats-styles-standings-stats">
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PLD' && p.TransLation === 'Away'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'W' && p.TransLation === 'Away'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'D' && p.TransLation === 'Away'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'L' && p.TransLation === 'Away'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GF' && p.TransLation === 'Away'">{{ p.Value }}</li>
                  <li class="LeagueStats-styles-goal-scored-conceded" v-for="p in s.WebLeagueTables" v-if="p.Key === 'GA' && p.TransLation === 'Away'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'GD' && p.TransLation === 'Away'">{{ p.Value }}</li>
                  <li v-for="p in s.WebLeagueTables" v-if="p.Key === 'PTS' && p.TransLation === 'Away'" class="LeagueStats-styles-strong">{{ p.Value }}</li>
                </ul>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="MiniStatsSlider-styles-slide" tabindex="-1" style="width: 100%; display: inline-block;">
            <div class="">
              <h3 class="SlideThree-styles-strong">{{ t.latest_matches }}</h3>
              <div class="SlideThree-styles-line SlideThree-styles-line-matches-title"></div>
              <div class="RecentMeetings-styles-match" v-for="m in data.h2h.Matches1.Matches.slice(0,5)">
                <div class="RecentMeetings-styles-match-date">{{ m.ActualStartTime | moment('Y.MM.DD') }}</div>
                <div class="RecentMeetings-styles-competitors">
                  <span class="RecentMeetings-styles-competitor RecentMeetings-styles-home"
                        :class="(m.HomeTeam[0].name == data.h2h.EntityList[0]['Name']) ? 'RecentMeetings-styles-strong' : ''">
                    {{ m.HomeTeam[0].name }}</span>
                  <span class="RecentMeetings-styles-score">
                    <span :class="(m.HomeTeam[0].name == data.h2h.EntityList[0]['Name'] || m.AwayTeam[0].name == data.h2h.EntityList[0]['Name'] ) ? 'RecentMeetings-styles-strong' : ''">{{ m.HomeScore }}</span>:
                    <span :class="(m.HomeTeam[0].name == data.h2h.EntityList[0]['Name'] || m.AwayTeam[0].name == data.h2h.EntityList[0]['Name']) ? 'RecentMeetings-styles-strong' : ''">{{ m.AwayScore }}</span>
                  </span>
                  <span class="RecentMeetings-styles-competitor RecentMeetings-styles-away"
                  :class="(m.AwayTeam[0].name == data.h2h.EntityList[0]['Name']) ? 'RecentMeetings-styles-strong' : ''">
                    {{ m.AwayTeam[0].name }}
                  </span>
                </div>

              </div>
              <div class="SlideThree-styles-line SlideThree-styles-line-matches-title"></div>

              <div class="RecentMeetings-styles-match" v-for="m in data.h2h.Matches2.Matches.slice(0,5)">
                <div class="RecentMeetings-styles-match-date">{{ m.ActualStartTime | moment('Y.MM.DD') }}</div>
                <div class="RecentMeetings-styles-competitors">
                  <span class="RecentMeetings-styles-competitor RecentMeetings-styles-home"
                        :class="(m.HomeTeam[0].name == data.h2h.EntityList[1]['Name']) ? 'RecentMeetings-styles-strong' : ''">
                    {{ m.HomeTeam[0].name }}</span>
                  <span class="RecentMeetings-styles-score">
                    <span :class="(m.AwayTeam[0].name == data.h2h.EntityList[1]['Name'] || m.HomeTeam[0].name == data.h2h.EntityList[1]['Name'] ) ? 'RecentMeetings-styles-strong' : ''">{{ m.HomeScore }}</span>:
                    <span :class="(m.AwayTeam[0].name == data.h2h.EntityList[1]['Name'] || m.HomeTeam[0].name == data.h2h.EntityList[1]['Name']) ? 'RecentMeetings-styles-strong' : ''">{{ m.AwayScore }}</span>
                  </span>
                  <span class="RecentMeetings-styles-competitor RecentMeetings-styles-away"
                        :class="(m.AwayTeam[0].name == data.h2h.EntityList[1]['Name']) ? 'RecentMeetings-styles-strong' : ''">
                    {{ m.AwayTeam[0].name }}
                  </span>
                </div>

              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'matchStats',
  props: ['matchId'],
  components: {VueContentLoading},
  data () {
    return {
      data: null,
      t: this.$root.t,
      loading: true,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        // init: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  watch: {
    matchId () {
      this.fetchStats()
    }
  },
  mounted() {

    this.fetchStats()
  },
  methods: {
    fetchStats () {
      this.loading = true;
      this.$http.get(bsapi + 'api/v1/stat-service/h2/'+this.matchId, {
        params: {match: this.$route.params.event, app: this.$root.app.id, onlyList: 1},

      }).then(response => {
        // get body data
        this.data = response.body;

        if(!this.data.h2h)
          this.data = null

        this.loading = false

      }, response => {
        // error callback
        this.data = null;
        this.loading = false

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider-1, .slider-2 {
  padding-bottom: 70px;
}
.stats-wrapper {
  background-image: linear-gradient(0deg,var(--white),var(--grey-iron));
  font-size: 13px;
  color: var(--grey-dark);
  position: relative;
  border-bottom: 1px solid var(--grey-iron);
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 25%);
}
.swiper-button-prev, .swiper-button-next {
  position: absolute;
  top: 98%;
  width: 27px;
  height: 12px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat;
}

.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E);
  right: 30%;
  left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E);
  left: 30%;
  right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/matchStats.vue